// extracted by mini-css-extract-plugin
export var cartContainer = "_pq-4";
export var gray = "_pq-1";
export var itemContainer = "_pq-2";
export var itemDetails = "_pq-3";
export var strong = "_pq-0";